<template>
  <router-link class="nav-link" :to="to" v-bind="$attrs" :expand="expand" :secondLinks="{}" :class="{ active: isActive }"
    @mouseenter="positionFlyout">
    <div
      class="text-center bg-white shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center me-2">
      <slot name="icon"></slot>
    </div>
    <div class="w-100 d-flex align-items-center justify-content-between">
      <span class="nav-link-text ms-1">{{ navText }} </span>
      <i v-if="expand" class="fa-solid fa-chevron-down" :class="{ visible: openHover }"></i>
    </div>
  </router-link>
  <template v-if="expand">
    <div ref="collapse" class="collapse">
      <ul class="nav ms-4">
        <li v-for="(item, index) in secondLinks" :key="index" class="nav-item">
          <a class="nav-link nav-link-collapse" :href="item.to" @click="handleResourceClick" :title="item.navText">
            <span class="sidenav-normal">{{ item.navText }}</span>
          </a>
        </li>
      </ul>
    </div>
  </template>
</template>

<script>
export default {
  name: "SidenavCollapse",
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
    expand: {
      type: Boolean,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
    },
    secondLinks: {
      type: Array,
      validator: (value) => Array.isArray(value),
    },
    openHover: {
      type: Boolean,
    }
  },
  data() {
    return {
    };
  },
  methods: {
    // Alinea el flyout (posición fixed) con el ítem sobre el que se hace hover,
    // manteniéndolo dentro del viewport.
    positionFlyout(e) {
      if (!this.expand) return;
      if (!window.matchMedia("(min-width: 1200px)").matches) return;
      const rect = e.currentTarget.getBoundingClientRect();
      this.$nextTick(() => {
        const collapse = this.$refs.collapse;
        if (!collapse) return;
        const panelHeight = Math.min(collapse.scrollHeight || 0, window.innerHeight * 0.6);
        const maxTop = window.innerHeight - panelHeight - 12;
        const top = Math.max(12, Math.min(rect.top, maxTop));
        collapse.style.top = `${top}px`;
      });
    },
    handleResourceClick() {
      this.$emit('resource-clicked');
    },
  },
};
</script>

<style scoped>
/* @media (min-width: 1200px){ */
.nav-item .collapse {
  display: none;
}

.nav-item:hover .collapse {
  display: initial;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 26px -4px rgb(20, 20, 20, 0.15), 0 8px 9px -5px rgb(20, 20, 20, 0.06);
  transition: all 0s;
  min-width: 200px;
}

.nav-item:hover ul::before {
  font-family: "";
  content: "";
  width: 20px;
  height: 40px;
  position: absolute;
  top: 7px;
  left: -8px;
  transition: top 0.35s ease;
}

aside#sidenav-main.sidenav .nav-item .collapse ul .nav-link span::first-letter {
  text-transform: uppercase;
}

aside#sidenav-main.sidenav .nav-item .collapse ul {
  list-style-type: none;
  min-height: 53.59px;
}

/* } */
.sidenav[data-color=success] .navbar-nav>.nav-item>.nav-link.active .icon {
  background-image: linear-gradient(310deg, var(--blue-accent) 0%, var(--blue-accent) 100%);
}

.navbar-vertical.bg-white .navbar-nav .nav-link .icon {
  background-image: linear-gradient(310deg, var(--background) 0%, var(--background) 100%);
}

.fa-chevron-down {
  opacity: 0;
  transform: rotate(-90deg);
  transition: transform 0.5s ease-in-out;
}

.fa-chevron-down.visible {
  opacity: 1;
}

.nav-item:hover .nav-link .fa-solid.fa-chevron-down {
  transform: rotate(0deg);
}

@media (max-width: 1200px) {
  ul.nav.ms-4 {
    margin-left: 2.5rem !important;
  }
}
</style>